import { NgModule,APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ProfileComponent } from './profile/profile.component'
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Location, LocationStrategy, HashLocationStrategy} from '@angular/common';
//import { UploaderModule  } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { DatePipe } from '@angular/common'
import { IonicNativePlugin } from '@ionic-native/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'primeng/toast';;
import { ConfirmDialogService } from './service/confirm-dialog.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@NgModule({
  declarations: [AppComponent,ProfileComponent],
  //entryComponents: [],
  imports: [ConfirmDialogModule,CalendarModule,ButtonModule,MessagesModule,MessageModule,ToastModule, BrowserAnimationsModule, NgApexchartsModule,NgxPaginationModule,NgSelectModule,BrowserModule, IonicModule.forRoot(), AppRoutingModule,HttpClientModule,FormsModule
    //,IonSelect, IonSelectOption, IonToast,IonText ,IonLoading ,
  ] ,
  
  providers: [ConfirmDialogService,ConfirmationService,DatePipe,IonicNativePlugin,BsDropdownModule,MessageService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    //{ provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
